export const caloAddress = '0xb6b91269413b6B99242B1c0Bc611031529999999';
export const ifitAddress = '0x73052f51b68d974d2ed6cec7b9e817adac168168';
